module.exports = __webpack_public_path__ + "img/cm_promo.96c6471f.svg";